module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-inner"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props && !_vm.loading) ? _c('div', {
    staticClass: "pages-content"
  }, [_c('Header'), _c('div', {
    staticClass: "main_content"
  }, [_c('div', {
    staticClass: "heroslider"
  }, [(_vm.props.acf.new_patient_banner_img_1) ? _c('div', {
    staticClass: "heroslide",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.new_patient_banner_img_1 + ')'
    })
  }, [_c('div', {
    staticClass: "herooverlay"
  })]) : _vm._e(), (_vm.props.acf.new_patient_banner_img_2) ? _c('div', {
    staticClass: "heroslide",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.new_patient_banner_img_2 + ')'
    })
  }, [_c('div', {
    staticClass: "herooverlay"
  })]) : _vm._e(), _c('div', {
    staticClass: "heroslidecaptions"
  }, [_c('div', {
    staticClass: "manual_container"
  }, [_c('div', {
    staticClass: "herotitle"
  }, [(_vm.props.acf.new_patient_banner_title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.new_patient_banner_title)
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "hero_subtitle"
  }, [(_vm.props.acf.new_patient_banner_subtitle) ? _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.new_patient_banner_subtitle)
    }
  }) : _vm._e()])])])]), _c('div', {
    staticClass: "newpatient_section"
  }, [_c('div', {
    staticClass: "manual_container"
  }, [(_vm.props.acf.first_visit_title) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.first_visit_title)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "hero_divider"
  }, [(_vm.props.acf.common_divider_img) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.common_divider_img,
      "alt": ""
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "intronewpatient"
  }, [(_vm.props.acf.first_visit_content) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.first_visit_content)
    }
  }) : _vm._e()])])]), (_vm.props.acf.first_visit_parallax) ? _c('div', {
    staticClass: "parralaximg",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.first_visit_parallax + ')'
    })
  }) : _vm._e(), _c('div', {
    staticClass: "officevisits_section"
  }, [_c('div', {
    staticClass: "manual_container"
  }, [(_vm.props.acf.get_started_title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.get_started_title)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "hero_divider"
  }, [(_vm.props.acf.common_divider_img) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.common_divider_img,
      "alt": ""
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "officevisitlists"
  }, [(_vm.props.acf.get_started_list) ? _c('ul', _vm._l((_vm.props.acf.get_started_list), function(VisitList) {
    return _c('li', [_c('h3', {
      domProps: {
        "innerHTML": _vm._s(VisitList.title)
      }
    }), _c('div', {
      staticClass: "hero_divider"
    }, [_c('img', {
      attrs: {
        "src": VisitList.number,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "offcevisit_content",
      domProps: {
        "innerHTML": _vm._s(VisitList.content)
      }
    })])
  })) : _vm._e()])])]), (_vm.props.acf.get_started_parallax) ? _c('div', {
    staticClass: "parralaximg",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.get_started_parallax + ')'
    })
  }) : _vm._e(), _c('div', {
    staticClass: "officevisits_section",
    attrs: {
      "id": "financial-info"
    }
  }, [_c('div', {
    staticClass: "manual_container"
  }, [(_vm.props.acf.financial_info_title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.financial_info_title)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "hero_divider"
  }, [(_vm.props.acf.common_divider_img) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.common_divider_img,
      "alt": ""
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "officevisitlists"
  }, [(_vm.props.acf.finance_list) ? _c('ul', _vm._l((_vm.props.acf.finance_list), function(FinanaceList) {
    return _c('li', [_c('h3', {
      domProps: {
        "innerHTML": _vm._s(FinanaceList.title)
      }
    }), _c('div', {
      staticClass: "hero_divider"
    }, [_c('img', {
      attrs: {
        "src": FinanaceList.number,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "offcevisit_content"
    }, [_c('div', {
      staticClass: "officeinner"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(FinanaceList.content)
      }
    }), (FinanaceList.insurance_btn_title) ? _c('span', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modalprivacy",
        modifiers: {
          "modalprivacy": true
        }
      }]
    }, [(FinanaceList.insurance_btn_title) ? _c('span', {
      staticClass: "btnmodelprivacy",
      domProps: {
        "innerHTML": _vm._s(FinanaceList.insurance_btn_title)
      }
    }) : _vm._e(), _c('b-modal', {
      attrs: {
        "id": "modalprivacy",
        "title": FinanaceList.insurance_popup_heading
      }
    }, [_c('div', {
      staticClass: "modal-content-main"
    }, [_c('div', {
      staticClass: "privacycontent",
      domProps: {
        "innerHTML": _vm._s(FinanaceList.insurance_popup_content)
      }
    })])])], 1) : _vm._e(), _c('div', {
      staticClass: "afterpopupsec"
    }, [_c('p', [(FinanaceList.after_popup_content) ? _c('i', {
      domProps: {
        "innerHTML": _vm._s(FinanaceList.after_popup_content)
      }
    }) : _vm._e()])])])])])
  })) : _vm._e()])])]), (_vm.props.acf.finanace_parallax) ? _c('div', {
    staticClass: "parralaximg",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.finanace_parallax + ')'
    })
  }) : _vm._e(), _c('div', {
    staticClass: "officevisits_section patientreward"
  }, [_c('div', {
    staticClass: "manual_container"
  }, [(_vm.props.acf.reward_title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.reward_title)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "hero_divider"
  }, [(_vm.props.acf.common_divider_img) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.common_divider_img,
      "alt": ""
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "rewardslist row"
  }, _vm._l((_vm.props.acf.reward_list), function(RewardList) {
    return (_vm.props.acf.reward_list) ? _c('div', {
      staticClass: "col-sm-6"
    }, [_c('h6', {
      domProps: {
        "innerHTML": _vm._s(RewardList.title)
      }
    }), _c('div', {
      staticClass: "reward_content",
      domProps: {
        "innerHTML": _vm._s(RewardList.content)
      }
    })]) : _vm._e()
  }))])]), (_vm.props.acf.reward_parallax) ? _c('div', {
    staticClass: "parralaximg",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.reward_parallax + ')'
    })
  }) : _vm._e(), _c('div', {
    staticClass: "newpatient_section communityoutreach"
  }, [_c('div', {
    staticClass: "manual_container"
  }, [(_vm.props.acf.community_title) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.community_title)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "hero_divider"
  }, [(_vm.props.acf.common_divider_img) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.common_divider_img,
      "alt": ""
    }
  }) : _vm._e()]), (_vm.props.acf.community_content) ? _c('div', {
    staticClass: "intronewpatient",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.community_content)
    }
  }) : _vm._e()])])]), _c('Footer')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dafabbe","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/new-patients/new-patients.pug
// module id = 830
// module chunks = 1